<!-- W44 I5: the register's list toolbar (the RFIs page's pills and search pill), so both tabs filter alike -->
<div class="list-toolbar as-built-filters">
  <div class="status-chips" role="group" aria-label="Review status">
    <button type="button" class="toggle-pill" data-testid="as-built-status-all" [class.toggle-pill--on]="statusFilter === ''" [attr.aria-pressed]="statusFilter === ''"
      (click)="setStatus('')">All <span class="chip-count">{{ countAll }}</span></button>
    @for (s of statuses; track s) {
      <button type="button" class="toggle-pill" [attr.data-testid]="'as-built-status-' + s" [class.toggle-pill--on]="statusFilter === s" [attr.aria-pressed]="statusFilter === s"
        (click)="setStatus(s)">{{ statusCopy[s] }} <span class="chip-count">{{ counts[s] }}</span></button>
    }
  </div>
  <mat-form-field class="filter-pill" [class.filter-pill--on]="!!sheet.value" data-testid="as-built-sheet">
    <mat-select [formControl]="sheet" disableOptionCentering panelClass="rfi-sort-panel" aria-label="Sheet">
      <mat-select-trigger>Sheet: {{ sheetLabel }}</mat-select-trigger>
      <mat-option value="">All</mat-option>
      @for (s of sheets; track s.uuid) { <mat-option [value]="s.uuid">{{ s.number }}</mat-option> }
    </mat-select>
    <mat-icon matSuffix class="pill-chevron" svgIcon="chevron-down" aria-hidden="true" />
  </mat-form-field>
  @if (sheet.value && revisions.length) {
    <mat-form-field class="filter-pill" [class.filter-pill--on]="!!revision.value" data-testid="as-built-revision">
      <mat-select [formControl]="revision" disableOptionCentering panelClass="rfi-sort-panel" aria-label="Revision">
        <mat-select-trigger>Revision: {{ revisionLabel }}</mat-select-trigger>
        <mat-option value="">All</mat-option>
        @for (r of revisions; track r.uuid) { <mat-option [value]="r.uuid">{{ r.label ? 'Rev ' + r.label : 'Unlabelled revision' }}</mat-option> }
      </mat-select>
      <mat-icon matSuffix class="pill-chevron" svgIcon="chevron-down" aria-hidden="true" />
    </mat-form-field>
  }
  <div class="search">
    <mat-icon svgIcon="search"></mat-icon>
    <input id="as-built-search" type="text" class="search-input" maxlength="120" placeholder="Sheet, title, author or revision label (C)" aria-label="Search as-built marks"
      data-testid="as-built-search" [formControl]="search" />
    @if (search.value) {
      <mat-icon svgIcon="close" role="button" aria-label="Clear the search" data-testid="as-built-search-clear" (click)="search.setValue('')"></mat-icon>
    }
  </div>
</div>

@if (canPublish && selected.size) {
  <div class="bulk-bar" role="region" aria-label="Review selected marks" data-testid="as-built-bulk">
    <div class="bulk-line">
      <span class="mat-body-1 bulk-count" data-testid="as-built-selected">{{ selected.size }} selected</span>
      @if (!bulkAction) {
        @for (a of bulkActions; track a) {
          <button type="button" class="tool-button" [attr.data-testid]="'as-built-bulk-' + a" [disabled]="!canTake(a)"
            [title]="canTake(a) ? '' : 'None of the selected marks can be changed this way'" (click)="startBulk(a)">{{ actionCopy[a] }}</button>
        }
        <button type="button" class="link-button" data-testid="as-built-clear" (click)="clearSelection()">Clear</button>
      }
    </div>
    @if (bulkAction) {
      <div class="bulk-confirm" data-testid="as-built-bulk-confirm">
        <span class="mat-body-1" data-testid="as-built-bulk-summary">{{ actionCopy[bulkAction] }}: {{ canTake(bulkAction) }} {{ canTake(bulkAction) === 1 ? 'mark' : 'marks' }}</span>
        @if (canTake(bulkAction) < selected.size) {
          <span class="secondary-text mat-body-1" data-testid="as-built-bulk-skipped">{{ selected.size - canTake(bulkAction) }} selected can't take this action and will be left as they are.</span>
        }
        <app-text-area class="bulk-field" data-testid="as-built-bulk-comment" [parentFormGroup]="bulkForm" controlName="comment"
          [label]="bulkAction === 'rejected' ? 'Why are they rejected?' : 'Comment (optional)'" [maxLength]="2000" />
        @if (bulkError) {
          <span class="bulk-error mat-body-1" role="alert" data-testid="as-built-bulk-error">{{ bulkError }}</span>
        }
        @if (offenders.length) {
          <ul class="offenders mat-body-1" data-testid="as-built-offenders" aria-label="Marks that could not change">
            @for (o of offenders; track o.uuid) {
              <li><span class="offender-label">{{ o.label }}</span><span class="secondary-text">{{ o.reason }}</span></li>
            }
          </ul>
        }
        <div class="bulk-actions">
          @if (offenders.length) {
            @if (retryable.length) {
              <button type="button" class="tool-button tool-button--on" data-testid="as-built-bulk-retry" [disabled]="bulkBusy" (click)="retryWithoutOffenders()">
                {{ actionCopy[bulkAction] }}: the other {{ retryable.length }}</button>
            }
          } @else {
            <button type="button" class="tool-button tool-button--on" data-testid="as-built-bulk-apply" [disabled]="bulkBusy || !canTake(bulkAction)" (click)="confirmBulk()">{{ actionCopy[bulkAction] }}</button>
          }
          <button type="button" class="link-button" data-testid="as-built-bulk-cancel" [disabled]="bulkBusy" (click)="cancelBulk()">Cancel</button>
        </div>
      </div>
    }
  </div>
}

@if (loading && !rows.length) {
  <p role="status">Loading as-built marks…</p>
} @else if (!rows.length) {
  <div class="empty-state" data-testid="as-built-empty">
    @if (statusFilter || sheet.value || search.value) {
      No as-built marks match these filters.
    } @else {
      No as-built marks yet. In Redline, choose As-built to record a deviation.
    }
  </div>
} @else {
  <div class="table-scroll-wrapper">
    <table class="table as-built-table" data-testid="as-built-table">
      <thead>
        <tr>
          @if (canPublish) {
            <th class="col-select"><mat-checkbox color="primary" aria-label="Select all marks on this page" data-testid="as-built-select-all" [checked]="allSelected"
              [indeterminate]="!!selected.size && !allSelected" (change)="toggleAll($event.checked)"></mat-checkbox></th>
          }
          <th class="col-thumb"><span class="visually-hidden">Mark</span></th>
          <th>Sheet</th>
          <th>Author</th>
          <th>Date</th>
          <th>Status</th>
          <th>Linked record</th>
          <th>Last comment</th>
          <th class="col-actions"><span class="visually-hidden">Actions</span></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.uuid) {
          <tr class="as-built-row" data-testid="as-built-row" [attr.data-mark-uuid]="row.uuid" [class.as-built-row--selected]="selected.has(row.uuid)" (click)="open(row)">
            @if (canPublish) {
              <td class="col-select" (click)="$event.stopPropagation()">
                <mat-checkbox color="primary" data-testid="as-built-select" [attr.aria-label]="'Select the mark on ' + row.sheet.number"
                  [checked]="selected.has(row.uuid)" (change)="toggle(row, $event.checked)"></mat-checkbox>
              </td>
            }
            <td class="col-thumb">
              <!-- The page image (when the API sends it) with the strokes on top, both zoomed to the mark once the aspect is known -->
              @let c = crop(row);
              <div class="mark-thumb" data-testid="as-built-thumb">
                @for (url of thumbLayers(row); track url) {
                  <img #thumb class="mark-thumb-img" [class.mark-thumb-img--crop]="!!c" [src]="url" alt="" loading="lazy"
                    [style.width.%]="c ? c.width * 100 : null" [style.left.%]="c ? c.left * 100 : null" [style.top.%]="c ? c.top * 100 : null"
                    (load)="onThumbLoad(row, thumb)" (error)="onThumbError(url)" />
                }
              </div>
            </td>
            <td>
              <span class="mono">{{ row.sheet.number }}</span> · Rev {{ row.revision.label }}
              @if (row.revision.status !== 'issued') {
                <span class="secondary-text"> ({{ row.revision.status === 'superseded' ? 'Superseded' : 'Withdrawn' }})</span>
              }
              @if (row.carried_from_uuid) { <div class="secondary-text mat-caption">Carried forward</div> }
            </td>
            <td>{{ row.created_by?.name || '—' }}</td>
            <td class="nowrap">{{ row.created_at | date: 'MMM d, y' }}</td>
            <td><span class="status-badge status-chip" [attr.data-status]="row.review_status" data-testid="as-built-status">{{ statusCopy[row.review_status] }}</span></td>
            <td>
              <!-- 7.2: the record the mark was made from opens from here; a deleted record says so -->
              @if (canOpenRecord(row)) {
                <button type="button" class="link-button record-link" data-testid="as-built-record" (click)="openRecord(row, $event)">{{ recordText(row) }}</button>
              } @else if (recordText(row); as text) {
                <span [class.secondary-text]="row.linked_record?.deleted" data-testid="as-built-record-text">{{ text }}</span>
              } @else {
                —
              }
            </td>
            <td class="col-comment"><span class="comment" [title]="comment(row)">{{ comment(row) || '—' }}</span></td>
            <td class="col-actions" (click)="$event.stopPropagation()">
              <button type="button" mat-icon-button data-testid="as-built-row-menu" [matMenuTriggerFor]="rowMenu" [attr.aria-label]="'Options for the mark on ' + row.sheet.number"><mat-icon>more_horiz</mat-icon></button>
              <mat-menu #rowMenu="matMenu" class="tab-more-menu" xPosition="before">
                <button mat-menu-item type="button" data-testid="as-built-open" (click)="open(row)">Open on sheet</button>
                @if (canDelete(row)) {
                  <button mat-menu-item type="button" data-testid="as-built-delete" (click)="remove(row)">Delete</button>
                }
              </mat-menu>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (totalRecords > pageSize) {
    <mat-paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex" [hidePageSize]="true" (page)="page($event)"></mat-paginator>
  }
}
